import FilterDatePicker from "components/FilterDatePicker";
import { endOfDay } from "date-fns";
import { useIntl } from "react-intl";

type EventEndDatePickerProps = {
  value?: Date;
  onChange: (value: Date | undefined) => void;
};

export default function EventEndDatePicker({
  value,
  onChange,
}: EventEndDatePickerProps) {
  const { formatMessage: t } = useIntl();
  const onChangeInternal = (date: Date | undefined) => {
    onChange(date ? endOfDay(date) : date);
  };

  return (
    <FilterDatePicker
      label={t({ id: "endDate" })}
      value={value}
      onChange={onChangeInternal}
    />
  );
}
